/* eslint-disable react/prop-types */
import AnalyticsProvider from '@root/core/src/contexts/analytics/analytics-provider';
import ErrorBoundary from '@root/core/src/components/error-boundary';
import GTMDistinctIdReporter from '@root/joinroot.com/src/components/gtm-distinct-id-reporter';
import OptimizelyTrackingController from '@root/joinroot.com/src/components/optimizely-tracking-controller';
import React from '@root/vendor/react';
import SentryInitializationController from '@root/joinroot.com/src/components/sentry-initialization-controller';
import TrackVisitAttributionController from '@root/attribution/src/components/track-visit-attribution-controller';

export const MARKETING_PREFIX = 'MARKETING_WEBSITE';

export default function wrapRootElement({ element }) {
  return (
    <>
      <ErrorBoundary showErrorScreen={false}>
        <GTMDistinctIdReporter />
        <SentryInitializationController />
        <TrackVisitAttributionController />
        <AnalyticsProvider eventPrefix={MARKETING_PREFIX}>
          <OptimizelyTrackingController />
          {element}
        </AnalyticsProvider>
      </ErrorBoundary>
    </>
  );
}
